// Projects and maintenance items are listed with `assignee: {id, display_name}` (the user id), not a flat
// `assigned_to` field; `assigned_to` only exists on the detail response and in write payloads. The Dashboard's
// "mine" / technician filters and its "unassigned" count read `assigned_to` off the list rows, so with
// real data every row looked unassigned and both filters emptied the Projects and Maintenance tabs.
export const assigneeUserId = (item) => item?.assignee?.id ?? item?.assigned_to ?? null;
